import { Meteor } from 'meteor/meteor'

import { dispatch } from '../store'
import { SET_CATEGORIES } from '../reducers/categories'

export const fetchCategories = async (activeDeleted = false) => {
  const categories = await Meteor.promise('getCategories', null, true, activeDeleted)

  dispatch({
    type: SET_CATEGORIES,
    payload: categories,
  })
}
